import { createApp, devtools } from "vue";
import App from "./App.vue";
import "./assets/css/public.css";
import "./assets/js/ref.js";
import VueI18n from './language'
createApp(App,{devtools: false})
.use(VueI18n)
.mount("#app");
